module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/fairmont-800.60df6615f5083b88.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/fairmont-800.60df6615f5083b88.jpg",width: 800,height: 620}],
        src: "https://static.sniffspot.com/packs/img/fairmont-800.60df6615f5083b88.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/fairmont-800.60df6615f5083b88.jpg"},
        
        width: 800,
        height: 620
      }